import { Search } from '@styled-icons/bootstrap/Search';
import { CompetitionListSchema } from '@/views/sports/components/CompetitionList/styles/CompetitionList.styles';

export const competitionListStyles: CompetitionListSchema = {
  skeleton: {
    startColor: 'beta.300',
    endColor: 'beta.400',
    minW: 'full',
    h: '20',
    borderRadius: 'md',
    flex: 1,
    mt: '8',
  },
  input: {
    name: 'x',
    sxWrapper: { mb: '0' },
    bg: 'blackAlpha.600 ',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.05)',
    borderRadius: 'md',
    color: 'whiteAlpha.500',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: '2xs',
    mb: '0',
    _hover: {
      borderColor: 'alpha.500',
      bg: 'blackAlpha.600',
      borderRadius: 'md',
    },

    _focus: {
      boxShadow: 'xl',
      borderColor: 'alpha.500',
      color: 'alpha.500',
      textShadow: 'sm',
      bg: 'blackAlpha.700',
    },
  },
  inputRightIcon: {
    color: 'alpha.300',
    boxSize: '4',
    as: Search,
  },
  accordion: {
    color: 'white',
    mb: '3',
    variant: 'unstyled',
    w: 'full',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    py: '1',
    borderBottom: '1px',
    borderBottomColor: 'blackAlpha.400',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
    _first: {
      borderTop: 'none',
    },
  },
  accordionButton: {
    px: '0',
    pos: 'relative',
    _hover: { bg: 'transparent' },
  },
  hStack: {
    w: 'full',
    alignItems: 'center',
  },
  flex: { alignItems: 'center', gap: 2, flex: 1, textAlign: 'left' },
  accordionButtonIconSvg: {
    color: 'beta.500',
    fontSize: 'md',
  },
  accordionButtonText: {
    fontSize: ['2xs', 'sm'],
    fontFamily: 'Spectral',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
  },
  marketTypesFlex: {
    mr: '2',
    gap: '2',
  },
  marketTypesText: {
    w: ['50px', '100px'],
    fontSize: '2xs',
    fontWeight: 'bold',
  },
  accordionButtonInnerIcon: {
    pos: 'absolute',
    right: '0',
    boxSize: '6',
    color: 'beta.500',
  },
  accordionPanel: {
    p: '0',
    mb: '3',
    mx: '1px',
  },
};
